import React from "react";
import { IoCloudDone } from "react-icons/io5";
import { RiErrorWarningFill } from "react-icons/ri";

const StatusMessage = ({ status, error }) => (
  <div>
    {status ? (
      <div>
        <p className="bg-green-300 font-lufga rounded-md shadow-md px-2 py-1 text-xs flex items-center gap-1 justify-center border-l-4 border-green-900 ">
          <IoCloudDone size={18} className="text-green-900" />
          {status}
        </p>
      </div>
    ) : error ? (
      <div>
        <p className="bg-red-300 font-lufga rounded-md shadow-md px-2 py-1 text-sm flex items-center gap-1 justify-center border-l-4 border-red-900">
          <RiErrorWarningFill size={15} className="text-red-900" />
          {typeof error === "string"
            ? error
            : Object.keys(error).map((key) =>
                Array.isArray(error[key]) ? error[key][0] : error[key]
              )}
        </p>
      </div>
    ) : null}
  </div>
);

export default StatusMessage; 